import React from "react";
import { useNavigate } from "react-router-dom";

export const Logo = ({ className = "", onClick }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) onClick();
    else navigate("/");
  };
  return (
    <button
      data-testid="logo-button"
      onClick={handleClick}
      className={`flex items-center group ${className}`}
      aria-label="Startsidan"
    >
      <img
        src="/valfrimobil-logo.webp"
        alt="ValfriMobil"
        className="h-9 w-auto transition-transform group-hover:scale-105"
      />
    </button>
  );
};

export default Logo;
